module.exports = __webpack_public_path__ + "static/media/StripsCircled.45d820c5.svg";